import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PresenterResourcesService {

  constructor(private store: Store<any>) {}

  /**
   * Get learner maps from Redux store accessGroupData
   * Uses main_menu.learner_maps which contains the actual learner map data
   */
  getLearnerMaps(): Observable<any[]> {
    return this.store.select<any>((state) => {
      const mainMenu = state?.profile?.accessGroupData?.main_menu?.learner_maps;
      console.log('📊 Redux store - main_menu.learner_maps:', mainMenu);
      return mainMenu || {};
    }).pipe(
      tap(data => console.log('✅ Retrieved learner_maps from store:', data))
    );
  }

  /**
   * Transform learner maps object to array and format for component
   */
  formatLearnerMapsToContainer(learnerMapsObj: any): any[] {
    console.log('🔄 Formatting learner maps object:', learnerMapsObj);
    
    if (!learnerMapsObj || typeof learnerMapsObj !== 'object') {
      console.log('❌ No learner maps object to format, returning empty array');
      return [];
    }

    // Convert object to array, filtering out internal properties
    const formatted = Object.entries(learnerMapsObj)
      .map(([key, value]: [string, any]) => {
        console.log(`Processing learner map - key: ${key}`, value);
        return {
          title: value?.title || key,
          img_link: `${environment.s3_upload}/images/dashboard_images/teams/my_teams.png`,
          active: true,
          lm_id: value?.value || key,
          routerlink: value?.value || key
        };
      })
      .filter(item => item.title && item.title !== 'My Profile' && item.title !== 'Presenting' && item.title !== 'Promoting');
    
    console.log('✅ Formatted learner maps:', formatted);
    return formatted;
  }

  /**
   * Get learner maps as formatted container objects for component binding
   */
  getFormattedLearnerMaps(): Observable<any[]> {
    return this.getLearnerMaps().pipe(
      map(learnerMapsObj => this.formatLearnerMapsToContainer(learnerMapsObj)),
      tap(formatted => {
        console.log('📤 Final formatted maps for component:', formatted);
        console.log(`📊 Total learner maps to display: ${formatted.length}`);
      })
    );
  }
}
